<template>
  <v-sheet
    style="position: relative;"
  >
    <v-card flat>
      <v-card-title flex>
        <v-file-input show-size label="File input" @change="onFileSelected" :value="value"></v-file-input>
        <v-text-field
          v-model="search"
          clear-icon="mdi-close"
          clearable
          append-icon="mdi-magnify"
          label="Search"
          class="mx-12"
        ></v-text-field>
        <v-btn depressed color="green" @click="upload" :disabled="loading">Upload</v-btn>
      </v-card-title>
      <v-data-table
        class="mb-2 flex-center-between"
        style="flex-direction: row-reverse;"
        :headers="headers"
        :items="contacts"
        :search="search"
        @click:row="onContactSelected"
      >
        <template v-slot:item.tuition="{ item }">
          {{item.tuition | currencyTuition}}
        </template>
        <template v-slot:item.meetingDate="{ item }">
          {{item.meetingDate | familiarizeDate}}
        </template>
        <template v-slot:item.handledDate="{ item }">
          {{item.handledDate | SimplizedDate}}
        </template>
        <template v-slot:item.uploadStatus="{ item }">
          <v-chip :color="getColor(item.uploadStatus)">{{ item.uploadStatus }}</v-chip>
        </template>
      </v-data-table>
      <contact-viewer :contact="selectedContact" :dialog="dialog"></contact-viewer>
    </v-card>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactViewer from '@/modules/contact/ContactViewer'
import Papa from 'papaparse'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    ContactViewer
  },
  data () {
    return {
      search: '',
      dialog: false,
      selectedContact: {},
      migratedContacts: [],
      value: null,
      headers: [
        { text: 'Upload Status', value: 'uploadStatus', align: 'left', sortable: false },
        { text: 'Tên Phụ Huynh', value: 'parentName' },
        { text: 'Tên Học Sinh', value: 'name' },
        { text: 'Điện Thoại Phụ Huynh', value: 'parentPhone' },
        { text: 'Email Phụ Huynh', value: 'parentEmail' },
        { text: 'Level Sale', value: 'level' },
        { text: 'Ngày xử lý ', value: 'handledDate' },
        { text: 'Ngày Trải Nghiệm', value: 'meetingDate' },
        { text: 'Nguồn ', value: 'provider' },
        { text: 'PIC ', value: 'assignee.username' },
        { text: 'Học Phí', value: 'tuition' }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['department', 'users']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('migration', ['contacts', 'loading'])
  },
  methods: {
    ...mapActions('migration', ['fetchContacts', 'setContacts', 'setContact', 'migrateContacts', 'validateContacts']),
    onFileSelected (file) {
      let self = this
      let reader = new FileReader()
      reader.onload = function () {
        let contacts = Papa.parse(reader.result, { header: true })
        contacts.data.map((contact, index) => {
          if (contact.level) {
          } else {
            contact.level = 'L1A'
          }
          self.$utils.cleanObject(contact)
          if (contact.handledDate) {
            contact.handledDate = moment(contact.handledDate, 'DD/MM/YYYY').toISOString()
          } else {
            delete contact.handledDate
          }

          if (contact.handleDate) {
            contact.handleDate = moment(contact.handleDate, 'DD/MM/YYYY').toISOString()
          } else {
            delete contact.handleDate
          }

          if (contact.meetingDate) {
            contact.meetingDate = moment(contact.meetingDate, 'DD/MM/YYYY').toISOString()
          } else {
            delete contact.meetingDate
          }

          if (contact.onboard) {
            contact.onboard = moment(contact.onboard, 'DD/MM/YYYY').toISOString()
          } else {
            contact.onboard = moment().toISOString()
          }

          if (contact.dob) {
            contact.dob = moment(contact.dob, 'DD/MM/YYYY').toISOString()
          } else {
            delete contact.dob
          }
          if (contact.level) {
            contact.level = contact.level.split('-')[0].trim()
          }
          if (contact.assignee) {
            const index = self.users.findIndex(d => d.username === contact.assignee.toLowerCase())
            contact.assignee = (index > 0) ? self.users[index] : self.user.id
          }
          contact.uploadStatus = 'validate'
          contact.department = self.department.id
          contact.key = index
        })
        self.setContacts(contacts.data)
        self.validateContacts()
      }
      reader.readAsText(file)
    },
    getColor (status) {
      if (status === 'ready') return 'green'
      else if (status === 'success') return 'blue'
      else if (status === 'failed') return 'red'
      else if (status === 'loading') return 'gray'
      else if (status === 'duplicated') return 'orange'
      else if (status === 'validate') return 'gray'
    },
    upload () {
      this.migrateContacts()
    },
    onContactSelected (contact) {
      let duplicatedContact = _.get(contact, 'duplicated.parentPhone') || _.get(contact, 'duplicated.phone') || _.get(contact, 'duplicated.parentEmail') || _.get(contact, 'duplicated.email')
      if (duplicatedContact) {
        this.selectedContact = duplicatedContact
        this.dialog = !this.dialog
      }
    }
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format(' hh:mm Ngày DD/MM')
    },
    currencyTuition: (tuition) => {
      if (!tuition) {
        return '0 đ'
      }
      return new Intl.NumberFormat('vn-VN', { style: 'currency', currency: 'VND' }).format(tuition)
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM')
    }
  }
}
</script>

To change the font size for a single component, such as a text field, application-wide:

<style>
  .v-select__level-sale {
    font-size: 1em;
    border: none
  }
</style>
